module.exports = '<svg width="28" height="32" viewBox="0 0 28 32"><path d="M27 10h-8a1 1 0 0 1-1-1V1a1 1 0 0 0-1-1H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h24c1.106 0 2-.894 2-2V11a1 1 0 0 0-1-1zm-7.298 12.878a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 0 1-1.414 0l-2.878-2.878-2.868 2.868a1 1 0 0 1-1.414 0L8.3 24.282a1 1 0 0 1 0-1.414L11.166 20l-2.868-2.868a1 1 0 0 1 0-1.414l1.414-1.414a1 1 0 0 1 1.414 0l2.868 2.868 2.878-2.878a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414L16.822 20l2.88 2.878zM21 8h6c.552 0 .684-.316.292-.708L20.706.706C20.316.316 20 .448 20 1v6a1 1 0 0 0 1 1z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/close-document-1.js
// module id = 1071
// module chunks = 14